/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../app/store';
import { _Tokens, _Wallet } from '../../types';
import ApiSingWallet from '../../libs/apiSingWallet';
import API from 'libs/apiBsc';
import { DEFAULT_WALLET_SYMBOL } from '../../libs/constans';
import { ReceiptProps } from './TransactionToken';

type PopupState = {
    step: number,
    prevStep: number,
    nftTab: boolean,
    nftDetails: boolean,
    nftToken: any,
    nftMetadata: any,
    action: number | null,
    token: _Tokens | null,
    wallet: _Wallet | null,
    defaultWalletSymbol: string,
    ratio: {
        BNB: number,
        SING: number,
        BUSD: number,
        ES: number,
        VND: number,
    },
    receiptValue: ReceiptProps,
    isUpdated: boolean;
}

const initialState: PopupState = {
    step: 1,
    prevStep: 1,
    nftTab: false,
    nftDetails: false,
    nftToken: null,
    nftMetadata: null,
    action: null,
    token: null,
    wallet: null,
    defaultWalletSymbol: DEFAULT_WALLET_SYMBOL,
    ratio: {
        BNB: 0,
        SING: 0,
        BUSD: 0,
        ES: 0,
        VND: 0,
    },
    receiptValue:{
        reception_address: "",
        amount: 0,
    },
    isUpdated: false
}

export const popupSlice = createSlice({
    name: 'popupSlice',
    initialState: initialState,
    reducers: {
        changePopupStep: (state, { payload }: PayloadAction<number>) => {
            state.step = payload;
        },
        setPrevStep: (state, { payload }: PayloadAction<number>) => {
            state.prevStep = payload;
        },
        setNftTab: (state, { payload }: PayloadAction<boolean>) => {
            state.nftTab = payload;
        },
        setNftDetails: (state, { payload }: PayloadAction<boolean>) => {
            state.nftDetails = payload;
        },
        setNftToken: (state, { payload }: PayloadAction<any>) => {
            state.nftToken = payload;
        },
        setNftMetadata: (state, { payload }: PayloadAction<any>) => {
            state.nftMetadata = payload;
        },
        changePopupAction:  (state, { payload }: PayloadAction<number>) => {
            state.action = payload;
        },
        changePopupTokenSelected:  (state, { payload }: PayloadAction<_Tokens>) => {
            state.token = payload;
        },
        changePopupWalletSelected:  (state, { payload }: PayloadAction<_Wallet>) => {
            state.wallet = payload;
        },
        setRatio: (state, { payload }: PayloadAction<{ symbol: string, price: number }>) => {
            var obj = {}
            obj[payload.symbol] = payload.price
            state.ratio = Object.assign(state.ratio, obj)
        },
        setReceiptValue: (state, {payload}: PayloadAction<ReceiptProps>) =>{
            state.receiptValue = payload
        },
        setUpdate: (state) =>{
            state.isUpdated = !state.isUpdated;
        },
        clearReceiptState: (state) =>{
            state.receiptValue ={
                reception_address: "",
                amount: 0,
            }
        }

    }

})

export function getRatioBNBSING() {
    return async function fetchNftThunk(dispatch, getState) {
        const apiSing = new ApiSingWallet()
        const api = new API();
        var bnb = 0, sing = 0, busd = 0, es = 0;
        await apiSing.getPriceBNB().then(
            (result) => {
                bnb = Number(result.price)
            },
            (error) => {
                console.log(error!.message)
            }
        )
        await apiSing.getPriceSing().then(
            (result) => {
                sing = Number(result.price)
            },
            (error) => {
                console.log(error!.message)
            }
        )

        await apiSing.getRatio('BUSDUSDT').then(
            (result) => {
                busd = Number(result.price)
            },
            (error) => {
                console.log(error!.message)
            }
        )

        await apiSing.getRatio('ESUSDT').then(
            (result) => {
                es = Number(result.price)
            },
            (error) => {
                console.log(error!.message)
            }
        )
        
        dispatch(setRatio({ symbol: "BNB", price: bnb }))
        dispatch(setRatio({ symbol: "SING", price: sing }))
        dispatch(setRatio({ symbol: "BUSD", price: busd }))
        dispatch(setRatio({ symbol: "ES", price: es }))
    }
}
export const popupSelector = (state: RootState) => state.popup;

export const {
    changePopupStep,
    changePopupAction,
    setNftTab,
    setNftDetails,
    setNftToken,
    setNftMetadata,
    changePopupTokenSelected,
    changePopupWalletSelected,
    setPrevStep,
    setRatio,
    setReceiptValue,
    setUpdate,
    clearReceiptState
} = popupSlice.actions;
